

























































































import { FatalError, RetriableError } from '@/types/Errors'
import { NivaChatMessage } from '@/types/NivaType'
import { fetchEventSource } from '@microsoft/fetch-event-source'
import axios from 'axios'
import sanitizeHtml from 'sanitize-html'
import showdown from 'showdown'
import Vue from 'vue'

export default Vue.extend({
    props:['userAccessToken', 'nivaBaseUrl'],
    name: 'NivaChat',
    async mounted() {
        this.state.loading = false
        this.state.success = true
    },
    data() {
        return {
            chatHistory: [] as NivaChatMessage[],
            userInput: '',
            // nivaChatMap: {} as Record<string, NivaChatMessage>,
            nivaAccessToken: '',
            state: {
                loading: true,
                success: false,
                nivaAnswering: false,
                queryQueued: false
            },
            showdonConverter: new showdown.Converter({tables: true}),
            nivaClient: axios.create({
                baseURL: this.nivaBaseUrl,
            }),
            errorMessage: `Oops! Something went wrong. 😥
                We apologize for the inconvenience. An unexpected error occurred on our server.
                Please try again later, and thank you for your patience!
                If you continue to experience issues, feel free to contact our support team.`
        }
    },
    methods: {
        transformMessage(message: string) {
            return sanitizeHtml(this.showdonConverter.makeHtml(message))
        },
        isChatFromUser(chat: NivaChatMessage) {
            return chat.from === 'user'
        },
        generateId(isUser = false) {
            return (crypto as any).randomUUID() + (isUser ? '_user' : '_niva')
        },
        async formSubmit(){
            if(!this.userInput || this.state.nivaAnswering) return

            // Generate User Chat Info
            const userId = this.generateId(true)
            this.chatHistory.push(this.generateChatMessage(userId,'user', this.userInput))
            const query = this.userInput
            this.userInput =''
            this.state.nivaAnswering = true

            // Generate Niva Chat Info
            const nivaId = this.generateId()
            let nivaChat = this.generateChatMessage(nivaId, 'niva', '', true)

            // Put here to mutate here instead of looping the chat history when onMessage triggers.
            // this.nivaChatMap[nivaId] = nivaChat
            this.chatHistory.push(nivaChat)

            // one sse = one message conversation
            const requestBody = {
                query
            }

            try {
                await this.messageNiva(requestBody)
            } catch(err) {
                if(this.axios.isAxiosError(err) && err?.response?.status == 401) {
                    await this.$store.dispatch('getUserInfo')
                }

                // Try Again
                try {
                    await this.messageNiva(requestBody)
                } catch (err) {
                    this.state.queryQueued = false
                    nivaChat.completed = true
                    nivaChat.loading = false
                    nivaChat.message = this.errorMessage
                    this.state.nivaAnswering = false
                }

            }

            if(this.state.queryQueued) {
                const queryUrl = new URL(this.nivaBaseUrl)
                queryUrl.pathname = '/chat_stream'
                await fetchEventSource(queryUrl.toString(), {
                    headers: {
                        'Authorization': `Bearer ${this.userAccessToken}`,
                    },
                    onmessage: (evt) => {
                        let parsedData = {event:'', message: ''}

                        try{
                            parsedData = JSON.parse(evt.data)
                        }
                        catch(e){
                            // Ignore
                        }

                        const message = parsedData.message || ''
                        switch(parsedData.event) {
                        case 'thread.message.created':
                        case 'thread.message.delta':
                            nivaChat.loading = false
                            nivaChat.message += message
                            break
                        case 'thread.run.completed':
                        case 'thread.message.completed':
                            nivaChat.completed = true
                            nivaChat.message = message
                            break
                        case 'thread.message.failed':
                        case 'thread.run.failed':
                            throw new FatalError(message)
                        case 'thread.run.requires_action':
                            break
                        case 'thread.not.found':
                            throw new RetriableError(message)
                        default:
                            break
                        }
                    },
                    onclose: () => {
                        nivaChat.loading = false
                        this.state.nivaAnswering = false
                        nivaChat.completed = true

                        if(!nivaChat.message) {
                            nivaChat.message = this.errorMessage
                        }
                        console.log('Closing connection')
                    },
                    onerror: (err) => {
                        if(err instanceof FatalError) {
                            console.log(err)
                            nivaChat.completed = true
                            nivaChat.loading = false
                            nivaChat.message = this.errorMessage
                            this.state.nivaAnswering = false
                            throw err
                        }
                        console.error('Fetch event source error:', err)
                    }
                })
            }
        },
        generateChatMessage(id: string, from: string, message: string, loading = false) {
            return {
                id,
                from,
                message,
                loading,
                completed: false
            }
        },
        scrollChatMessages() {
            if(this.$refs.chatMessages){
                (this.$refs.chatMessages as any).scrollTop = (this.$refs.chatMessages as any).scrollHeight
            }

        },
        async messageNiva(requestBody: {query: string}) {
            const splittedPage= this.$store.getters.page.split('_')

            const payload = {
                query: requestBody.query,
                page: this.$store.getters.page,
                dataSource: splittedPage.length > 1 ? splittedPage[0] : 'IQ',
                pageAlias: this.$store.getters.pageAlias
            }

            await this.nivaClient.post('/chat_query', payload, {
                headers: {'Authorization': `Bearer ${this.userAccessToken}`}
            })
            this.state.queryQueued = true
        }
    },
    watch: {
        chatHistory() {
            this.$nextTick(()=> {this.scrollChatMessages()})
        }
    }
})
